// Mui
import { styled } from "@mui/system";
import { Button } from "@mui/material";

// Utils
import { shouldForwardProp } from "utils";

type SquaredButtonProps = {
    width?: number | string;
    height?: number | string;
    color?: "secondary";
};

export const SquaredButton = styled(Button, {
    shouldForwardProp: (prop) => shouldForwardProp<SquaredButtonProps>(["width", "height", "color"], prop),
})<SquaredButtonProps>(({ width = 80, height = 67, color, theme }) => ({
    width,
    height,
    fontWeight: 600,
    minWidth: "auto",
    display: "block",
    padding: theme.spacing(0, 1),
    marginLeft: theme.spacing(0.7),
    borderRadius: theme.spacing(0.5),
    color: theme.palette.common.white,
    backgroundColor: color === "secondary" ? theme.palette.success.main : theme.palette.button.active.from,
    "& [data-hideonhover]": {
        display: "block",
        margin: "auto",
    },
    "& [data-showonhover]": {
        display: "none",
    },
    "&:hover": {
        background: color === "secondary" ? "none" : "linear-gradient(94.61deg, #102F52 11.74%, #267895 113.82%)",
        backgroundColor: color === "secondary" ? theme.palette.success.dark : theme.palette.button.active.from,
        "& [data-hideonhover]": {
            display: "none",
        },
        "& [data-showonhover]": {
            display: "block",
            margin: "auto",
        },
    },
    "&:disabled": {
        color: theme.palette.text.alt,
        opacity: "35%",
        pointerEvents: "none",
        filter: "grayscale(80%)",
    },
}));
